import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
export var NotificationDrawerList = function NotificationDrawerList(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isHidden = _a.isHidden,
      isHidden = _a$isHidden === void 0 ? false : _a$isHidden,
      props = __rest(_a, ["children", "className", "isHidden"]);

  return React.createElement("ul", Object.assign({}, props, {
    className: css(styles.notificationDrawerList, className),
    hidden: isHidden
  }), children);
};